<template>
    <!-- <Button class="ms-2 addbtn" @click="$emit('addbtn')"> <i :class="iconClass" class="mx-2"></i><span v-if="btnimg">
            <img :src="btnimg" alt=""></span> {{ btnname }}</Button> -->
    <Button class="ms-3 addbtn" @click="$emit('addbtn')" :loading="loading"><i
            :class="[iconClass, { 'me-2': iconClass }]"></i><span v-if="btnimg">
            <img :src="btnimg" alt=""></span> {{ btnname }}</Button>
</template>
<script lang="ts">
import { defineComponent, ref } from "vue";
// import "bootstrap/dist/css/bootstrap.css";
export default defineComponent({
    props: {
        btnname:
        {
            type: String,
            default: ''
        },
        iconClass: {
            type: String,
            default: ''
        },
        btnimg: {
            type: String,
            default: ''
        },
        loading: {
            type: Boolean,
            default: false
        }
    },
    setup() {
        return {};
    },
});
</script>
<style lang="scss">
@import '../../assets/variables.scss';

.addbtn {
    background-color: $AddButton !important;
    border: none !important;
    padding: 0.65rem 0.65rem 0.55rem 0.65rem !important;
    font-size: 14px !important;
    white-space: nowrap;
    border-radius: 8px !important;
    color: #FFFFFF !important;

    i {
        font-size: 12px;
    }

    img {
        width: 13px;
        margin-right: 5px;
    }
}
</style>